import fetch from '@/utils/fetch'
import request from './request'
import config from '@/config'
const policyBaseUrl = config.service.apiUrl+'/policy'

export default {
  calculatePremium(policy) {
    return request({
      url:  policyBaseUrl + '/za/calculate',
      method: 'post',
      data: policy
    });
  },
  save(policy, code) {
    return request({
      url:  policyBaseUrl + '/za/save?messageCode='+code,
      method: 'post',
      data: policy
    });
  },
  quotation(policy,orderProductCode) {
    return request({
      url:  policyBaseUrl + '/za/uwOrder',
      method: 'post',
      data: policy,
      params:{
        orderProductCode
      }
    });
  },
  fetchMessageCode(phone) {
    return request({
      url:  policyBaseUrl + '/messageCode/send',
      method: 'post',
      data: {
        phone
      }
    });
  },
  getPolicyListByOrderId(orderId) {
    return request({
      url:  policyBaseUrl + '/za/queryByOrderId',
      method: 'post',
      data: {
        orderId
      }
    });

  },
  fetchSendCode(policyId) {
    return request({
      url:  policyBaseUrl + '/za/sendCode',
      method: 'post',
      data: {
        policyId
      }
    });
  }
}